const loadElectron = function(file) {
	
	if ( window.navigator.userAgent.indexOf('Electron') <= 0 ) 
		{ 
			return false; 
		}
	
	
	var agoraf = {};
	var clientf = {};
	var $ = window.$ || {};
	var initNetworkOnce = false;
	var initVideoState = false;
	var initVideoDeviceState = false;
	var initAudioDeviceState = false;
	var initVideoStateCall = false;
	agoraf['checkSystemRequirements'] = function () { return true; }
	
	agoraf['createClient'] = function (val)
		{
			console.log('Init Agora electron');
			
			clientf['agora'] = new window.AgoraRtcEngine();
			
			clientf['enableAudioVolumeIndicator'] = function () {
				
				clientf['agora'].enableAudioVolumeIndication(2000, 3, false);
				return true;
			}

			clientf['setEncryptionMode'] = function () {
				clientf['agora'].setEncryptionMode(process.env.REACT_APP_ENC_MODE);
				return true;
			}

			clientf['setEncryptionSecret'] = function () {
				clientf['agora'].setEncryptionSecret(process.env.REACT_APP_ENC_SECRET);
				return true;
			}

			let currentUserData = JSON.parse(localStorage.getItem("userData"));
			let audioProfileNative = currentUserData.default.setAudioProfileNative.split(',');
			clientf['setAudioProfile'] = function () {
				clientf['agora'].setAudioProfile(parseInt(audioProfileNative[0]), parseInt(audioProfileNative[1]));
				return true;
			}

			clientf['startProxyServer'] = function () {
				console.log('startProxyServer');
				//clientf['agora'].setParameters("{\"rtc.enable_proxy\":true}");
				return true;
			}

			clientf['init'] = function (idapp, callbck, errcallbck) {
				
				var issuc = clientf['agora'].initialize(idapp);
				if ( issuc == 0 ) { callbck(); } else { errcallbck('unable to initialize electron services, code -> ' + issuc + ' appId: ' + idapp); }
			}
			
			clientf['setClientRole'] = function (clrole)
				{
					clientf['agora'].setChannelProfile(1);
					clientf['agora'].setClientRole(clrole); //- role only for live-broadcast, where audience don't have publishing video
				}
			
			clientf['join'] = function (channel_key, channelName, userid, callbck, errcallbck)
				{
					var issuc = clientf['agora'].joinChannel(channel_key, channelName, null, userid);
					if ( issuc == 0 ) 
						{ 
							clientf['inChannel'] = true; 
							callbck(userid); 
						} 
					else 
						{ 
							errcallbck('unable to join electron AgoraRTC Channel, code -> ' + issuc + ' | channelKey: ' + channel_key + ' | channelName:' + channelName); 
						}
				}
			
			clientf['on'] = function (onname, onfunc)
				{
					if ( onname == 'peer-online' )
						{
							clientf['agora'].on('userJoined', function (uid) {
								onfunc({'uid': uid});
							});
						}
					
					if ( onname == 'stream-added' )
						{
							clientf['streamLater'] = onfunc;
						}
					
					if ( onname == 'volume-indicator' )
						{
							clientf['agora'].on('groupAudioVolumeIndication', function (speaker, spnum, totalVolume)
								{
									onfunc({'attr': speaker});
								});
						}
					
					if ( onname == 'stream-subscribed' )
						{
							clientf['agora'].on('userJoined', function (uid) {
								clientf['agora'].setupViewContentMode(uid, 1);
								onfunc({'stream': agoraf['createStream2'](uid)});
								
								if ( clientf['streamLater'] ) { clientf['streamLater']({'stream': agoraf['createStream2'](uid)}); }
							});
						}
					if ( onname == 'peer-leave' )
					{
						clientf['agora'].on('userOffline', function (uid,reason) {
							onfunc({'uid': uid,'reason':reason});
						});
					}
					if ( onname == 'first-video-frame-decode' )
					{
						clientf['agora'].on('firstRemoteVideoDecoded', function (uid,width) {
							onfunc({'stream': agoraf['createStream2'](uid)});
						});
					}
					if ( onname == 'first-audio-frame-decode' )
					{
						clientf['agora'].on('remoteAudioStateChanged', function (uid,state,reason) {
							onfunc({
									'stream': agoraf['createStream2'](uid),
									'reason': reason
								});
						});
					}
					if(onname == "streamInjectedStatus"){
						clientf['agora'].on('streamInjectStatus', function (url, uid, status) {
							onfunc({'uid': uid,'url':url,'status':status});
						});
					}
					
					console.log('Called on',  onname);

					/*clientf['agora'].on('remoteVideoStats', function (stats) {
						//$('#agora_remote_resolution'+stats.uid).text(`${stats.width}X${stats.height} | FPS: ${Math.floor(stats.rendererOutputFrameRate)} | PL: ${stats.packetLossRate}`);
					});*/

					if(!initNetworkOnce)
					{
						function updatenetworkStat(uid, txquality, rxquality) {
							window.networkQualityStats(uid, rxquality);
						}
					
						clientf['agora'].off('networkQuality', updatenetworkStat);
						clientf['agora'].on('networkQuality', updatenetworkStat);
						initNetworkOnce = true;
						
						clientf['agora'].on('connectionLost', function (state, reason) {
							if ( window.joinSDKAgain() ) { window.joinSDKAgain(); }
						});
					}
					
					if(!initVideoState){
						
						function updateVideoStat(uid, state, reason, elapsed) {
							window.remoteVideoStates(uid, state, reason, elapsed);
						}
						
						clientf['agora'].off('remoteVideoStateChanged', updateVideoStat);
						clientf['agora'].on('remoteVideoStateChanged', updateVideoStat);
						initVideoState = true;
					}

					if ( onname == 'connection-state-change' )
					{
						clientf['agora'].on('connectionStateChanged', function (state, reason) {
							console.log('connectionStateChanged - ', state, reason);
							onfunc({'curState': state});
						});
					}
				}
			
			clientf['leave'] = function (succ, err) 
				{ 
					console.log('leave channel'); 
					clientf['agora'].leaveChannel(); 
					succ();
					
					setTimeout(function(){
						clientf['agora'] = undefined;
					}, 3000);
				}
			
			clientf['muteAllRemoteVideoStreams'] = function (succ, err) { clientf['agora'].muteAllRemoteVideoStreams(true); }
			clientf['muteAllRemoteAudioStreams'] = function (succ, err) { clientf['agora'].muteAllRemoteAudioStreams(true); }

			clientf['publish'] = function (str, succ) { succ(); }
			clientf['enableDualStream'] = function (succ, err) { clientf['agora'].enableDualStreamMode(true); succ(); }
			clientf['disableDualStream'] = function (succ, err) { clientf['agora'].enableDualStreamMode(false); succ(); }
			clientf['setLowStreamParameter'] = function (param) { clientf['agora'].setLowStreamParameter(param) }
			clientf['setRemoteVideoStreamType'] = function (sttype, param) { clientf['agora'].setRemoteVideoStreamType(sttype.streamId, param); }
			clientf['addInjectStreamUrl'] = function (url, InjectStreamConfig) {  
				clientf['agora'].addInjectStreamUrl(url, InjectStreamConfig);
			}
			clientf['removeInjectStreamUrl'] = function (url) {
				clientf['agora'].removeInjectStreamUrl(url);
			}
			clientf['subscribe'] = function(stream, obj){
				obj && obj.hasOwnProperty("video") && this.agora.muteRemoteVideoStream(stream.streamId, !obj.video);
			}
			clientf['unsubscribe'] = function(stream, obj){}
			clientf['setStreamFallbackOption'] = function (str, succ) { }
			
			clientf['inChannel'] = false;
			clientf['setVideoRenderFPS'] = function (fps) { clientf['agora'].setVideoRenderFPS(fps); }
			window['globalAgora'] = clientf;
			
			return clientf;
		}
	
	
	agoraf['createStream'] = function (rmobject)
		{
			if ( clientf['agora'] == undefined )
				{
					var currentUserData = JSON.parse(localStorage.getItem("userData"));
					
					agoraf['createClient']();
					clientf['init'](currentUserData.sessionData.appId, function (okk) { console.log('okk ---', okk); }, function (er) { console.log('errr ---', er); window.captureElectronError('electronInit', er); });
				}
			var newStream = {};
			
			newStream['setVideoProfile'] = function (profile) {clientf['agora'].setVideoEncoderConfiguration(profile); }
			newStream['onFunc'] = {};
			
			newStream['on'] = function (onname, onfunc)
				{
					console.log('Called on',  onname);
					
					newStream['onFunc'][onname] = onfunc;
					
					if ( onname == 'accessAllowed' ) { onfunc(); }
					
					if ( onname == 'audioMixingPlayed' )
						{
							clientf['agora'].on('audioMixingStateChanged', function (state,error) {
									if ( state == '710' ) { if ( typeof newStream['onFunc']['audioMixingPlayed'] == 'function' ) { newStream['onFunc']['audioMixingPlayed'](); } }
									if ( state == '713' ) { if ( typeof newStream['onFunc']['audioMixingFinished'] == 'function' ) { newStream['onFunc']['audioMixingFinished'](); } }
								});
						}
					
					if ( onname == 'audioDeviceStateChanged' )
						{
							clientf['agora'].on('audioDeviceStateChanged', function (deviceId, deviceType, deviceState) {
									console.log('Audio device changed', deviceId, deviceType, deviceState);
									
									newStream['onFunc']['audioDeviceStateChanged'](deviceId, deviceType, deviceState);
								});
						}
					
					if ( onname == 'videoDeviceStateChanged' )
						{
							clientf['agora'].on('videoDeviceStateChanged', function (deviceId, deviceType, deviceState) {
									console.log('Video device changed', deviceId, deviceType, deviceState);
									
									newStream['onFunc']['videoDeviceStateChanged'](deviceId, deviceType, deviceState);
								});
						}
					
					if ( onname == 'audioDeviceVolumeChanged' )
						{
							clientf['agora'].on('audioDeviceVolumeChanged', function (deviceType, volume, muted) {
									console.log('audioDeviceVolumeChanged - deviceType - ', deviceType, ' volume - ', volume, ' muted - ', muted);
									
									newStream['onFunc']['audioDeviceVolumeChanged'](deviceType, volume, muted);
								});
						}

					if(!initVideoDeviceState){
						
						function updateVideoDeviceStateChange(deviceId, deviceType, deviceState) {
							console.log('videoDeviceStateChanged - ', deviceId, deviceType, deviceState);
							window.videoDeviceChanged(deviceId, deviceType, deviceState);
						}
					
						clientf['agora'].off('videoDeviceStateChanged', updateVideoDeviceStateChange);
						clientf['agora'].on('videoDeviceStateChanged', updateVideoDeviceStateChange);
						initVideoDeviceState = true;
					}

					if(!initAudioDeviceState){
						
						function updateAudioDeviceStateChange(deviceId, deviceType, deviceState) {
							console.log('audioDeviceStateChanged - ', deviceId, deviceType, deviceState);
							window.audioDeviceChanged(deviceId, deviceType, deviceState);
						}
					
						clientf['agora'].off('audioDeviceStateChanged', updateAudioDeviceStateChange);
						clientf['agora'].on('audioDeviceStateChanged', updateAudioDeviceStateChange);
						initAudioDeviceState = true;
					}
					
					

					if ( !initVideoStateCall )
						{
							clientf['agora'].on('error', function (err, msg) {
								console.log('error - ', err, ' - msg - ', msg);
							});

							clientf['agora'].on('warning', function (warn, msg) {
								console.log('warning - ', warn, ' - msg - ', msg);
							});
							
							function initVideoStateCallFunc(localVideoState, error)
								{
									if ( error == 2 || error == 4 ) 
										{
											window.mediaAccessAllowed = false;
											localStorage.removeItem('cameraAccessAllowed');
											console.log('shoooow5');
											$('#media-access-alert').modal('show');
											window.electronCameraError(2);
										}
									else if ( error == 3 && ( $('input[name="video-type"]').length == 1 || $('#chose_camera').length == 1 ) ) 
										{
											window.mediaAccessAllowed = false;
											localStorage.removeItem('cameraAccessAllowed');
											$('.try-again').addClass('d-none');
											$('#media-access-alert-text').text('Virdio is unable to access your camera or microphone even though access was granted. Please check if it’s being used by another app or restart your device.');
											console.log('shoooow6');
											$('#media-access-alert').modal('show');
											window.electronCameraError(3);
										} 
									else if ( error == 3 && ( $('input[name="video-type"]').length > 1 || $('#chose_camera').length > 1 ) ) 
										{
											localStorage.removeItem('cameraAccessAllowed');
											window.electronCameraAccess(true);
											window.electronCameraError(3);
										}
									else if ( error == 0 && ( $('input[name="video-type"]').length > 1 || $('#chose_camera').length > 1 )) 
										{
											if (window.mediaAccessAllowed === false) {
												window.electronCameraAccess(false);
											}
										}
									else if ( error == 8 ) 
										{
											localStorage.removeItem('cameraAccessAllowed');
											window.electronCameraError(8);
										}
									else if ( error == 1 ) 
										{
											window.electronCameraError(1);
										}
								}
							
							clientf['agora'].off('localVideoStateChanged', initVideoStateCallFunc);
							clientf['agora'].on('localVideoStateChanged', initVideoStateCallFunc);
							initVideoStateCall = true;
							
							clientf['agora'].off('audioRouteChanged', audioRouteChangedFunc);
							clientf['agora'].on('audioRouteChanged', audioRouteChangedFunc);
							
							function audioRouteChangedFunc(state, error)
								{
									if ( window['last_Device'] !== window['globalAgora'].agora.getCurrentAudioPlaybackDevice() )
										{
											window['last_Device'] = window['globalAgora'].agora.getCurrentAudioPlaybackDevice();
											window['globalAgora'].agora.setAudioPlaybackDevice(window['globalAgora'].agora.getCurrentAudioPlaybackDevice());
											
											// Get recording audio and video in sync
											setTimeout(function () { if ( window['stopRecordAndStartNew'] ) { window['stopRecordAndStartNew']('restartlocal'); } }, 2000);
										}
								}
						}
				}
			
			window['last_Device'] = '';
			newStream['getStats'] = function (onfunc) {
				if ( !clientf || !clientf['agora'] ) { return false; }
				clientf['agora'].on('rtcStats', function (statt) {
							onfunc({'accessDelay': statt.lastmileDelay});
						});
			}
			newStream['isPlaying'] = function () { return true; }
			newStream['init'] = function (succ, err) { succ(); }
			newStream['getId'] = function () { return this.streamObject; }
			
			newStream['play'] = function (elm)
			{
				console.log('play #######', this.streamObject.cameraId, this.streamObject.microphoneId, this.streamObject, elm);
				
				if ( this.streamObject && this.streamObject.cameraId ) { clientf['agora'].setVideoDevice(this.streamObject.cameraId); }
				if ( this.streamObject && this.streamObject.microphoneId ) { clientf['agora'].setAudioRecordingDevice(this.streamObject.microphoneId); }
				if ( this.streamObject && this.streamObject.speakerId ) { clientf['agora'].setAudioPlaybackDevice(this.streamObject.speakerId); }
				
				clientf['agora'].startPreview();
				clientf['agora'].setupLocalVideo( document.querySelector('#'+elm));

				window['last_Device'] = window['globalAgora'].agora.getCurrentAudioPlaybackDevice();
				window['globalAgora'].agora.setAudioPlaybackDevice(window['globalAgora'].agora.getCurrentAudioPlaybackDevice());
			}
			newStream['muteAudio'] = function (elm) { clientf['agora'].muteLocalAudioStream(true); }
			newStream['unmuteAudio'] = function (elm) { clientf['agora'].muteLocalAudioStream(false); }
			newStream['muteVideo'] = function (elm) { clientf['agora'].muteLocalVideoStream(true); }
			newStream['unmuteVideo'] = function (elm) { clientf['agora'].muteLocalVideoStream(false); }
			newStream['resume'] = function (elm) { }
			newStream['stop'] = function (elm) { clientf['agora'].destroyRender('local'); }
			newStream['getAudioLevel'] = function () { return 5; }
			newStream['changeStreamVolume'] = function (vol) { clientf['agora'].adjustPlaybackSignalVolume(vol); }
			newStream['close'] = function (elm) 
				{ 
					if ( clientf && clientf['agora'] )
						{
							clientf['agora'].release(); 
						}
					
				}
			
			newStream['switchDevice'] = function (dtype, deviceid, succ, err)
				{
					if ( dtype == 'video' )
						{
							this.streamObject.cameraId = deviceid;
							clientf['agora'].setVideoDevice(deviceid);
							succ();
							return true;
						}
					else if ( dtype == 'audio' )
						{
							clientf['agora'].setAudioRecordingDevice(deviceid);
							succ();
							return true;
						}
					else if ( dtype == 'speaker' )
						{
							clientf['agora'].setAudioPlaybackDevice(deviceid);
							succ();
							return true;
						}
					
					err();
					return false;
				}
			newStream['setHostType'] = function () { this.isHost = true; }
			
			newStream['startAudioMixing'] = function (data, callbck)
				{
					data['filePath'] = data['filePath'].split('\\').join('/');
					clientf['agora'].startAudioMixing(data['filePath'], (data['loopback'] ? true : false), false, 1, 0);
					callbck(false);
					
					clientf['agora'].setAudioRecordingVolume(255); // highest available to be louder than music in any case
				}
			newStream['adjustAudioMixingVolume'] = function (vol)
				{
					clientf['agora'].adjustAudioMixingVolume(vol);
				}
			newStream['adjustAudioMixingPublishVolume'] = function (vol)
				{
					clientf['agora'].adjustAudioMixingPublishVolume(vol);
				}
			
			newStream['getAudioMixingCurrentPosition'] = function ()
				{
					return clientf['agora'].getAudioMixingCurrentPosition();
				}
			newStream['getAudioMixingDuration'] = function ()
				{
					return clientf['agora'].getAudioMixingDuration();
				}
			newStream['resumeAudioMixing'] = function ()
				{
					clientf['agora'].resumeAudioMixing();
				}
			newStream['pauseAudioMixing'] = function ()
				{
					clientf['agora'].pauseAudioMixing();
				}
			newStream['stopAudioMixing'] = function ()
				{
					clientf['agora'].stopAudioMixing();
				}
			newStream['setAudioMixingPosition'] = function (posms)
				{
					clientf['agora'].setAudioMixingPosition(posms);
				}
			
			newStream['isHost'] = false
			
			newStream['streamId'] = rmobject['streamID'];
			newStream['streamObject'] = rmobject;

			console.log(rmobject);
			
			return newStream;
		}
	
	agoraf['createStream2'] = function (uid)
		{
			var newStream = {};
			
			newStream['setVideoProfile'] = function (prof)
				{
					var clp = clientf['agora'].setVideoEncoderConfiguration(prof);
					console.log('set prof', clp, prof);
				}
			newStream['on'] = function (onname, onfunc)
				{
					console.log('Called on',  onname);
					
					if ( onname == 'accessAllowed' ) { onfunc(); }

					/*
					clientf['agora'].on('remoteVideoStats', function (stats) {
						//console.log('remote video stats ---- ', stats);
					});*/
				}
			newStream['getId'] = function () { return this.streamId; }
			
			newStream['getStats'] = function (onfunc) {  }
			newStream['init'] = function (succ, err) { succ(); }
			
			newStream['play'] = function (elm)
			{
				var playElement;
				if ( window['multiWindow1'] && window['multiWindow1'].document && !window['multiWindow1'].closed)
					{
						playElement = window['multiWindow1'].document.getElementById(elm);
						
					}
				
				if ( window['multiWindow2'] && window['multiWindow2'].document && !window['multiWindow2'].closed && !playElement )
					{
						playElement = window['multiWindow2'].document.getElementById(elm);
					}
				
				if ( !playElement )
					{
						playElement = document.querySelector('#'+elm);
					}
				
				clientf['agora'].subscribe(this.streamId, playElement)
			}
			newStream['muteAudio'] = function (elm) { clientf['agora'].muteRemoteAudioStream(this.streamId, true); }
			newStream['unmuteAudio'] = function (elm) { clientf['agora'].muteRemoteAudioStream(this.streamId, false); }
			newStream['muteVideo'] = function (elm) { clientf['agora'].muteRemoteVideoStream(this.streamId, true); }
			newStream['unmuteVideo'] = function (elm) { clientf['agora'].muteRemoteVideoStream(this.streamId, false); }
			newStream['resume'] = function (elm) { }
			newStream['stop'] = function (elm) { }
			newStream['stopAudioMixing'] = function () { }
			newStream['close'] = function (elm) { }
			newStream['isPlaying'] = function () { return true; }
			newStream['setHostType'] = function () { this.isHost = true; }
			newStream['changeStreamVolume'] = function (vol) { clientf['agora'].adjustPlaybackSignalVolume(vol); }
			
			newStream['isHost'] = false
			newStream['streamId'] = uid
			newStream['streamObject'] = uid;
			newStream['destroyRender'] = function (elm, channelId) {
				clientf['agora'].destroyRender(elm, channelId);
			}
			
			
			return newStream;
		}
	
	agoraf['getDevices'] = function (callbck)
		{
			var currentUserData = JSON.parse(localStorage.getItem("userData"));
			
			if ( clientf['agora'] == undefined )
				{					
					agoraf['createClient']();
					let appId = (currentUserData.onDemand != undefined && currentUserData.onDemand == 1) ? currentUserData.rtmAppId : currentUserData.sessionData.appId;
					clientf['init'](appId, function (okk) { console.log('okk ---', okk); }, function (er) { console.log('errr ---', er); window.captureElectronError('electronInit', er); });
				}
			
			var videodev = clientf['agora'].getVideoDevices();
			var audiodev = clientf['agora'].getAudioRecordingDevices();
			var speakdev = clientf['agora'].getAudioPlaybackDevices();
			var devlist = [];
			
			if ( videodev && videodev.length > 0 ) { localStorage.setItem('videodev', JSON.stringify(videodev)); }
			else if ( !videodev && localStorage.getItem('videodev') ) { videodev = JSON.parse(localStorage.getItem('videodev')); }
			
			if ( videodev && videodev.length > 0 )
				{
					for ( let v of videodev )
						{
							v['kind'] = 'videoinput';
							v['deviceId'] = v['deviceid'];
							v['label'] = v['devicename'];
							devlist.push(v);
						}
				}
			
			
			if ( audiodev && audiodev.length > 0 ) { localStorage.setItem('audiodev', JSON.stringify(audiodev)); }
			else if ( !audiodev && localStorage.getItem('audiodev') ) { audiodev = JSON.parse(localStorage.getItem('audiodev')); }
			
			if ( audiodev && audiodev.length > 0 )
				{
					for ( let a of audiodev )
						{
							a['kind'] = 'audioinput';
							a['deviceId'] = a['deviceid'];
							a['label'] = a['devicename'];
							devlist.push(a);
						}
				}
			
			if ( speakdev && speakdev.length > 0 ) { localStorage.setItem('speakdev', JSON.stringify(speakdev)); }
			else if ( !speakdev && localStorage.getItem('speakdev') ) { speakdev = JSON.parse(localStorage.getItem('speakdev')); }

			if ( speakdev && speakdev.length > 0 )
				{
					for ( let a of speakdev )
						{
							a['kind'] = 'speaker';
							a['deviceId'] = a['deviceid'];
							a['label'] = a['devicename'];
							devlist.push(a);
						}
				}
			
			console.log('devices ----', devlist);
			
			callbck(devlist);
		}
	
	
			
	agoraf['startEchoTestWithInterval'] = function(dur){
		if ( clientf['agora'] == undefined )
			{
				var currentUserData = JSON.parse(localStorage.getItem("userData"));
				
				agoraf['createClient']();
				clientf['init'](currentUserData.sessionData.appId, function (okk) {console.log('okk ---', okk); }, function (er) { console.log('errr ---', er); window.captureElectronError('electronInit', er); });
			} 

		clientf['agora'].startEchoTestWithInterval(dur);
		return true;
	}
	
	agoraf['stopEchoTest'] = function(dur){
		if ( clientf['agora'] == undefined )
			{
				var currentUserData = JSON.parse(localStorage.getItem("userData"));
				
				agoraf['createClient']();
				clientf['init'](currentUserData.sessionData.appId, function (okk) { console.log('okk ---', okk); }, function (er) { console.log('errr ---', er); window.captureElectronError('electronInit', er); });
			}
		
		
		clientf['agora'].stopEchoTest();
		return true;
	}
	
	agoraf['switchMic'] = function(call)
		{
			if ( clientf['agora'] == undefined )
				{
					var currentUserData = JSON.parse(localStorage.getItem("userData"));
					
					agoraf['createClient']();
					clientf['init'](currentUserData.sessionData.appId, function (okk) { console.log('okk ---', okk); }, function (er) { console.log('errr ---', er); window.captureElectronError('electronInit', er); });
					call(clientf['agora']);
				}
			else 
				{
					call(clientf['agora']);
				}
		}
		
	agoraf['switchSpeaker'] = function(device_id)
		{
			if ( clientf['agora'] == undefined )
				{
					var currentUserData = JSON.parse(localStorage.getItem("userData"));
					
					agoraf['createClient']();
					clientf['init'](currentUserData.sessionData.appId, function (okk) { console.log('okk ---', okk); }, function (er) { console.log('errr ---', er); window.captureElectronError('electronInit', er); });
				}
			clientf['agora'].setAudioPlaybackDevice(device_id);
		}	
	
	window['AgoraElectron'] = agoraf;
}

export { loadElectron } 
